import React from 'react';
import bn from '../../../utils/bemnames';
import DropdownList from '../../GeneralForm/DropdownList';
import useWindowDimensions from '../../GeneralForm/useWindowDimensions';

const bem = bn.create('dashboard');

const TitleDropDown = ({ handleChangeDashboardId, ...props }) => {
  const { width } = useWindowDimensions();
  const breakpoint = 768;

  const DropDownstyle = {
    container: (base) => ({
      ...base,
      width: '100%',
    }),
    control: (base) => ({
      ...base,
      border: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
    }),
    singleValue: (base) => ({
      ...base,
      color: '#fff',
      backgroundColor: 'transparent',
      border: 0,
      padding: 0,
      fontSize: '2.5rem',
      fontWeight: 400,
      lineHeight: '48px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: '#fff',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#949494',
      '&:hover': {
        color: '#949494',
      },
    }),
    menuList: (base) => ({
      ...base,
      '::-webkit-scrollbar': {
        width: '10px',
        backgroundColor: '#ffffff',
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: 'rgb(0,0,0,0.2)',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#2F3B4D',
        border: '1px solid #ffffff',
        borderRadius: '5px',
      },
    }),
    option: (base, state) => ({
      ...base,
      fontSize: width > breakpoint ? '20px' : '14px',
      color: state.isSelected ? '#ffffff' : '#2f3b4d',
      backgroundColor: state.isSelected ? '#455d82' : '#ffffff',
      '&:hover': {
        backgroundColor: '#e6e6e6',
      },
    }),
  };
  const handleTitleChange = (e) => {
    handleChangeDashboardId(e);
  };

  return (
    <div className={bem.b('')}>
      <div className="row ">
        <div className="col-xl-7 col-lg-8">
          <div className="row">
            <span className="cr-title__title">
              <div className="">
                <DropdownList
                  options={props.dashboardIdOptions}
                  Dvalue={[props.dashboardID]}
                  handleChange={(e) => {
                    if (e !== null) {
                      handleTitleChange(e);
                    }
                  }}
                  style={DropDownstyle}
                  showDropdownIndicator
                  maxHeight={250}
                  isClearable={false}
                />
              </div>
            </span>
          </div>
        </div>
        <div className="col-xl-5 col-lg-4" />
      </div>
    </div>
  );
};

TitleDropDown.propTypes = {};

export default React.memo(TitleDropDown);
